import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.705rem calc(1.25rem + 73px)',
    padding: '0.5rem',
    border: '1px solid lightgray',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    fontSize: theme.size.sm,
    transition: 'all 200ms',

    '&:hover': {
      borderColor: '#E984FF'
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0.705rem 0'
    }
  },

  emailRoot: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '0.5rem',
    width: '100%',
    color: theme.palette.textLight,

    '& .emphasize': {
      marginRight: '0.25rem',
      fontWeight: theme.bold.bold
    },

    [theme.breakpoints.down('md')]: {
      textAlign: 'center'
    }
  },

  subjectBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  subject: {
    display: 'flex',
    alignItems: 'center'
  },

  time: {
    fontSize: theme.size.sm
  },

  sender: {
    display: 'flex',
    alignItems: 'center'
  },

  receiver: {
    display: 'flex',
    alignItems: 'center'
  },

  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  }
}))

export default useStyles
